__turbopack_context__.v({
  "searchSuggestions": "searchSuggestions-module-scss-module__gA9UIG__searchSuggestions",
  "suggestionsRow": "searchSuggestions-module-scss-module__gA9UIG__suggestionsRow",
  "title": "searchSuggestions-module-scss-module__gA9UIG__title",
});
